import React from "react";
import { Container } from "@mui/material";
import Header from "./components/Header";
import Motto from "./components/Motto";
import Slideshow from "./components/Slideshow";
import About from "./components/About";
import Ceo from "./components/Ceo";
import Team from "./components/Team";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./styles.css";

function App() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        backgroundColor: "#ffffff",
        padding: "20px",
        paddingTop: 0, // Remove top padding
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Header />
      <Motto />
      <Slideshow />
      <main>
        <About />
        <Ceo />
        <Team />
        <Services />
        <Contact />
      </main>
      <Footer />
    </Container>
  );
}

export default App;
